var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.announcement)?_c('marquee-text',{staticClass:"marquee",attrs:{"repeat":1},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.announcement.content)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }